import * as React from "react";
import {
  CustomerNotification as InlineNotification,
  CustomerNotificationLocation as InlineNotificationLocation,
} from "@shared-ui/customer-notifications-v2";
import { CustomerNotification, CustomerNotificationLocation } from "@shared-ui/customer-notifications";
import { PageStore } from "bernie-core";
import { inject } from "mobx-react";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";
import { Experiment as SharedUIExperiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";

interface TravelAdvisoryProps {
  context: ExtendedContextStore;
  page?: PageStore;
}

export const TravelAdvisory: React.FC<TravelAdvisoryProps> = inject("page")((props: TravelAdvisoryProps) => {
  const { context, page } = props;
  const isTravelAdvisoryExperimentEnabled = isVariantEnabled(
    context,
    Experiment.LP_SC_Covid19_TravelAdvisory_for_LandingPages
  );

  if (!page || !page.pageId || !context || !isTravelAdvisoryExperimentEnabled) {
    return null;
  }

  let regionId = context.searchContext?.location?.id?.toString() || "";

  if (context.searchContext?.location?.type === "hotel") {
    regionId = context.searchContext?.location?.parent.id?.toString() || "";
  }

  return (
    <div className="travelAdvisoryBanner uitk-cell all-cell-1-1 all-y-padding-three">
      <SharedUIExperiment name="notifications_spinner_kill_switch">
        <ExperimentControl>
          <CustomerNotification
            inputs={{
              xPageId: page.pageId,
              notificationLocation: CustomerNotificationLocation.AFTER_HEADER,
              optionalContext: {
                regionIds: [regionId],
              },
            }}
          />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <InlineNotification
            inputs={{
              xPageId: page.pageId,
              notificationLocation: InlineNotificationLocation.AFTER_HEADER,
              optionalContext: {
                journeyCriterias: [
                  {
                    destination: {
                      regionId: regionId,
                    },
                  },
                ],
              },
            }}
          />
        </ExperimentVariant>
      </SharedUIExperiment>
    </div>
  );
});

export default TravelAdvisory;
